@let content = content$ | async;
<ng-container>
  <div class="login">
    <section class="login-container">
      @if(content) {
        <h1 class="title" [innerHTML]="content.title"></h1>
      } @else {
        <ngx-skeleton-loader count="1" appearance="line" animation="progress" [theme]="{ height: '2.5rem'}"></ngx-skeleton-loader>
      }

      <section class="login-details-container">
        <article class="login-form">
          @if (landingConfig$ | async; as landingConfig) {
            <seth-login
              (loginPayload)="startEnrollment($event)"
              [programProductConfig]="landingConfig.programProductConfig"
              [userTypes]="landingConfig.userTypes"
              [hideSingleOptions]="landingConfig.hideSingleOptions || false"
            ></seth-login>
          }
        </article>
        <article class="login-description">
          <span class="description-text">
            @if(content) {
              <div [innerHTML]="content.description" class="paragraph-text"></div>
            } @else {
              <ngx-skeleton-loader count="2" appearance="line" animation="progress" [theme]="{ height: '5rem'}"></ngx-skeleton-loader>
            }
          </span>
        </article>
      </section>
    </section>
  </div>
</ng-container>
